import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { useEffect } from 'react';

import useConfirm from '../../hooks/useConfirm';

interface IProps {
  value: string;
}

const FuelConfirm = ({ value }: IProps) => {
  const { onConfirm, onCancel } = useConfirm();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (value) setOpen(true);
  }, [value]);

  const handleConfirm = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onConfirm();
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onCancel();
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>{value}</DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        <Button color="success" variant="contained" onClick={handleConfirm}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FuelConfirm;
